<template>
  <div>
    <div class="content_box">
      <div class="content_box_title">
        <div class="circle_l"></div>
        <div class="circle_r"></div>
        <div class="text_xl">提货查询</div>
      </div>
      <!-- 搜索筛选 -->
      <div>
        <div class="table_item_box">
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">用户代码</div>

              <input
                @change="search"
                v-model="screen.orderstartnumber"
                placeholder="请输入用户代码"
                class="table_item_input"
              />
            </div>
          </div>

          <div class="table_item_box_s" style="flex-direction: column-reverse">
            <div class="table_item_box_l_r"></div>
            <div class="table_item_box_l_s">
              <el-button type="primary" round @click="search">搜索</el-button>
              <el-button round @click="react">重置</el-button>
            </div>
          </div>
        </div>
        <div class="table_item_box" v-if="input && userInfo">
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">运单号</div>

              <input
                @change="toggleSelection()"
                v-model="screen.ordernumber"
                placeholder="请输入运单号"
                class="table_item_input"
              />
            </div>
          </div>
          <div class="table_item_box_s" style="flex-direction: column-reverse">
            <div class="table_item_box_l_r"></div>
            <div class="table_item_box_l_s">
              <el-button type="primary" @click="toggleSelection()" round
                >勾选</el-button
              >
              <el-button @click="alltoggleSelection" round>全选</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content_box" v-if="input && userInfo">
      <div class="table_box">
        <div>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
              :label="'货运提货(' + orderData.totalElements + ')'"
              name="first"
            >
              <div style="width: 100%; margin-bottom: 20px; display: flex">
                <div class="grid-content bg-purple" style="margin-right: 30px">
                  用户余额：{{ userInfo.balance }}
                </div>
                <div class="grid-content bg-purple" style="margin-right: 30px">
                  销售代表：{{ userInfo.aeniorName }}
                </div>
                <div class="grid-content bg-purple" style="margin-right: 30px">
                  取货地址：{{ userInfo.pickuplocation }}
                </div>
                <div
                  class="grid-content bg-purple-light"
                  style="margin-right: 30px"
                >
                  电话：{{ userInfo.canadaphonenumber }}
                </div>
              </div>

              <el-table
                v-loading="tableLoading"
                ref="multipleTable"
                :header-cell-style="{ background: '#E7EDF8', color: '#333333' }"
                :data="orderData.content"
                tooltip-effect="dark"
                style="width: 100%; margin-top: 20px"
                @selection-change="handleSelectionChange"
              >
                >
                <el-table-column
                  label-class-name="DisabledSelection"
                  type="selection"
                  width="100px"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="ordernumber"
                  label="运单号"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="domesticnumber"
                  label="国内运单号"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="loadDeliveryBatchName"
                  label="批次号"
                >
                </el-table-column>
                <el-table-column align="center" prop="baggagenum" label="箱数">
                </el-table-column>
                <el-table-column align="center" prop="weightkg" label="重量">
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="storagecost"
                  label="仓储费"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="shippingcost"
                  label="运费"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="pickUpLocationName"
                  label="取货点"
                >
                </el-table-column>
                <el-table-column align="center" label="详情">
                  <template slot-scope="scope">
                    <el-button @click="details(scope.row.id)" type="text"
                      >查看包裹详情</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <!-- （'+orderData.totalElements+'） -->
            <el-tab-pane label="商城团购提货" name="second">
              <el-table
                :header-cell-style="{ background: '#E7EDF8', color: '#333333' }"
                ref="multipleTable2"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
              >
                >
                <el-table-column
                  label-class-name="DisabledSelection"
                  type="selection"
                  width="100px"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="ordernumber"
                  label="运单号"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="domesticnumber"
                  label="国内运单号"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="loadDeliveryBatchName"
                  label="批次号"
                >
                </el-table-column>
                <el-table-column align="center" prop="baggagenum" label="箱数">
                </el-table-column>
                <el-table-column align="center" prop="weightkg" label="重量">
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="storagecost"
                  label="仓储费"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="shippingcost"
                  label="运费"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="pickUpLocationName"
                  label="取货点"
                >
                </el-table-column>
                <el-table-column align="center" label="详情">
                  <template slot-scope="scope">
                    <el-button @click="details(scope.row.id)" type="text"
                      >查看包裹详情</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <!-- （2） -->
            <el-tab-pane label="团购线到货" name="third">
              <el-table
                :header-cell-style="{ background: '#E7EDF8', color: '#333333' }"
                ref="multipleTable3"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
              >
                >
                <el-table-column
                  label-class-name="DisabledSelection"
                  type="selection"
                  width="100px"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="ordernumber"
                  label="运单号"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="domesticnumber"
                  label="国内运单号"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="loadDeliveryBatchName"
                  label="批次号"
                >
                </el-table-column>
                <el-table-column align="center" prop="baggagenum" label="箱数">
                </el-table-column>
                <el-table-column align="center" prop="weightkg" label="重量">
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="storagecost"
                  label="仓储费"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="shippingcost"
                  label="运费"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="pickUpLocationName"
                  label="取货点"
                >
                </el-table-column>
                <el-table-column align="center" label="详情">
                  <template slot-scope="scope">
                    <el-button @click="details(scope.row.id)" type="text"
                      >查看包裹详情</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="paging_boxs" v-if="orderData.totalElements > 0">
          <div class="paging_box_io">
            <div>共{{ orderData.totalElements }}单，</div>
            <div style="color: #5178ffff">
              已选择{{ multipleSelection.length }}单
            </div>
          </div>
          <div class="paging_box_io">
            <div class="text_ops">总运费：${{ shippingcost }}</div>
            <div class="text_ops">总仓储费：${{ storagecost }}</div>
            <div class="text_ops">总费用：${{ cost }}</div>
          </div>
        </div>
        <div class="paging_box">
          <el-button type="primary" @click="submitBtn(3)" round
            >现金付款</el-button
          >
          <el-button @click="submitBtn(0)" type="warning" round
            >余额付款</el-button
          >
        </div>
        <div class="paging_box">
          <el-pagination
            page-size="1000"
            @current-change="pageChange"
            background
            layout="prev, pager, next"
            :total="orderData.totalElements"
          >
          </el-pagination>
        </div>
        <!-- <el-row :gutter="20">
  <el-col :span="3"><div class="grid-content bg-purple">  用户余额：1455</div></el-col>
  <el-col :span="3"><div class="grid-content bg-purple">   销售代表：总仓01</div></el-col>
  <el-col :span="3"><div class="grid-content bg-purple">  取货地址：密市总仓</div></el-col>
  <el-col :span="3"><div class="grid-content bg-purple">电话：9053470713</div></el-col>
</el-row> -->
      </div>
    </div>
    <el-dialog
      title="确认付款"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="table_item_box_l_r">
        <div class="fill_in_title">优惠券码</div>

        <input
          v-model="couponNumber"
          placeholder="请输入优惠券码（选填）"
          class="table_item_input"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="loading" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="submit()" :loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import crudDept from "@/api/userMG";
export default {
  data() {
    return {
      couponNumber:'',
      tableLoading: "",
      loading: false,
      input: false,
      tableData: [],
      multipleSelection: [],
      activeName: "first",
      dialogVisible: false,
      orderData: {
        totalElements: 0,
      },
      type: "",
      shippingcost: 0,
      storagecost: 0,
      orderIds: [],
      cost: 0,
      screen: {
        page: 1,
        size: 1000,
        orderstartnumber: "",
        state: 30,
        ordernumber: "",
        queryType: 1,
        picktype: 1,
      },
      userInfo: "",
      payType: "",
    };
  },
  created() {
    // this.orderList()
  },
  methods: {
    alltoggleSelection() {
      this.$refs.multipleTable.toggleAllSelection();
    },
    toggleSelection() {
      var t = this;
      var number = this.screen.ordernumber;
      this.orderData.content.forEach((item, index) => {
        if (number == item.ordernumber) {
          this.$refs.multipleTable.toggleRowSelection(
            t.orderData.content[index],
            true
          );
          t.orderData.content.unshift(t.orderData.content.splice(index, 1)[0]);
        } else if (number == item.domesticnumber) {
          this.$refs.multipleTable.toggleRowSelection(
            t.orderData.content[index],
            true
          );
          t.orderData.content.unshift(t.orderData.content.splice(index, 1)[0]);
        }
      });
      setTimeout(() => {
        this.screen.ordernumber = "";
      }, 3000);
    },
    getUserInfo() {
      // this.orderList=[];
      var data = {
        userNumber: this.screen.orderstartnumber,
      };
      crudDept.getUserInfo(data).then((res) => {
        if (res) {
          this.userInfo = res;
          this.orderList();
        } else {
          this.userInfo = "";
          this.$message.error("未搜索到用户");
        }
      });
    },
    //确认提货付款
    submit() {
      this.loading = true;

      var data = {
        orderIds: this.orderIds,
        orderType: 0,
        payType: this.payType,
        totalShippingCost: this.shippingcost,
        totalStorageCost: this.storagecost,
        couponNumber:this.couponNumber,
      };

      crudDept
        .payOrder(data)
        .then((res) => {
          this.$message.success("操作成功");
          this.dialogVisible = false;
          this.$refs.multipleTable.clearSelection();
          this.orderIds = [];
          this.orderList();
          this.loading = false;
          this.couponNumber='';
          this.getUserInfo();
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //点击付款
    submitBtn(e) {
      this.payType = e;
      if (this.orderIds == "") {
        this.$message.error("请勾选提货订单");
        return false;
      }
      this.dialogVisible = true;
    },
    //重置
    react() {
      this.screen = {
        page: 1,
        size: 10,
        orderstartnumber: "",
        state: 30,
        ordernumber: "",
        queryType: 2,
        picktype: this.type,
      };
      this.userInfo = "";
      // this.getUserInfo();
    },
    //搜索
    search() {
      this.getUserInfo();
      this.input = true;
    },
    handleClick(e) {
      this.screen.picktype = e.index;
      this.type = e.index;
      this.$refs.multipleTable.clearSelection();
    },
    //分页
    pageChange(e) {
      this.screen.page = e;
      this.orderList();
    },
    selectRouteid(item) {
      this.$forceUpdate();
    },

    reset() {
      this.screen = {
        page: 1,
        size: 1000,
        code: "",
        state: 30,
        queryType: 2,
      };
    },
    //订单列表
    orderList() {
      this.tableLoading = true;
      crudDept
        .orderList(this.screen)
        .then((res) => {
          this.orderData = res;
          var data = res.content;
          var shippingcost = 0; //派送费
          var storagecost = 0; //运费
          // var orderIds = [];
          var isfromchina = [];
          this.cost = this.storagecost * 1 + this.shippingcost * 1;
          data.forEach((row) => {
            this.$refs.multipleTable.toggleRowSelection(row);
            shippingcost += row.shippingcost;
            storagecost += row.storagecost;
            // orderIds.push(row.id);
            isfromchina.push(row.isfromchina);
          });
          this.storagecost = storagecost.toFixed(2);
          this.shippingcost = shippingcost.toFixed(2);
          this.tableLoading = false;
        })
        .catch((res) => {
          this.tableLoading = false;
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      var data = val;
      var shippingcost = 0; //派送费
      var storagecost = 0; //运费
      var orderIds = [];
      var isfromchina = [];
      var index = 0;
      for (var i = 0; i < data.length; i++) {
        shippingcost += data[i].shippingcost;
        storagecost += data[i].storagecost;
        orderIds.push(data[i].id);
        isfromchina.push(data[i].isfromchina);
      }
      this.storagecost = storagecost.toFixed(2);
      this.shippingcost = shippingcost.toFixed(2);
      this.orderIds = orderIds;
      // this.isfromchinaData = isfromchina;
      this.cost = (this.storagecost * 1 + this.shippingcost * 1).toFixed(2);
    },
    details(e) {
      this.$router.push({
        path: "/parcel/parcelDetail?id=" + e + "&name=提货管理",
      });
    },
    productInformation() {
      this.$router.push({ path: "/parcel/productInformation" });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
  },
};
</script>
<style scoped>
.text_ops {
  /* font-size: 18px; */
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  margin-left: 20px;
}
.paging_box_io {
  display: flex;
}
.paging_boxs {
  display: flex;
  margin-top: 20px;
  align-items: center;
  justify-content: space-between;
}
.content_box >>> .el-table .DisabledSelection .cell .el-checkbox__inner {
  /* margin-left: -30px; */
  position: relative;
}
.content_box >>> .el-table__header-wrapper .el-checkbox__input::after {
  content: "全选";
  position: absolute;
  margin-left: 10px;
  font-weight: bold;
}
.confirm_btn {
  margin: 0 auto !important;
  background-color: #5178ff;
  width: 150px;
  height: 44px;
  background: #5178ff;
  box-shadow: 0px 3px 6px rgba(81, 120, 255, 0.1);
  opacity: 1;
  border-radius: 22px;
}
input::-webkit-input-placeholder {
  color: #999999;
}
input::-moz-input-placeholder {
  color: #999999;
}
input::-ms-input-placeholder {
  color: #999999;
}
.fill_in_list_box {
  display: flex;
  flex-wrap: wrap;
}
.fill_in_list {
  /* width: 27%; */
  border-bottom: 1px solid #dedede;
  /* padding-bottom: 10px; */
  padding-right: 10px;
  box-sizing: border-box;
  margin-bottom: 16px;
  margin-right: 22px;
}
.fill_in_list_l {
  display: flex;
  align-items: baseline;
}
.fill_in_title {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-right: 9px;
}
.fill_in_title_l {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #ff0e0e;
}
.numbers_info {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-bottom: 22px;
}
.el-dialog {
  display: flex;
  flex-direction: column;
  margin: auto !important;
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  /*height:600px;*/
  max-height: calc(100% - 30px) !important;
  max-width: calc(100% - 30px) !important;
}
.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
.table_box {
  margin-top: 32px;
}
.el-table td,
.el-table th {
  text-align: center !important;
}
.text_li {
  color: #ffa401 !important;
}
.el-button.is-round {
  border-radius: 14px;
  width: 110px;
  height: 40px;
}
.table_item_box_s {
  display: flex;
}
.table_item_box_l_s {
  display: flex;
}
.table_item_input >>> .el-input__inner {
  background: none !important;
  outline: none !important;

  border: none;
  color: #fff !important;
  padding: 0;
}
.content_box_title {
  display: flex;
  align-items: center;
}
.circle_l {
  width: 18px;
  height: 18px;
  background: #5178ff;
  border-radius: 50%;
}
.circle_r {
  width: 18px;
  height: 18px;
  background: rgba(81, 120, 255, 0.27);
  border-radius: 50%;
  margin-left: -7px;
}
.text_xl {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  margin-left: 20px;
  color: #333333;
}
.content_box {
  width: 100%;
  height: auto;
  background: #ffffff;
  padding: 38px 58px;
  margin-bottom: 12px;
  box-sizing: border-box;
}
.table_item_box {
  display: flex;
  align-items: flex-end;
  /* justify-content: space-between; */
  flex-wrap: wrap;
  padding: 25px 0 0;
  box-sizing: border-box;
}
.table_item_box_l {
  margin-right: 30px;
  text-align: left;
}
.table_item_box_l_r {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}
.table_item_input {
  width: 180px;
  height: 40px;
  background: #ffffff;

  border: 1px solid #dedede;
  opacity: 1;
  border-radius: 10px;
  margin-left: 10px;
  padding: 0 15px !important;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.input_select {
  width: 100%;
  height: 40px;
  background: #ffffff;

  border: none;
  opacity: 1;

  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.input_select >>> .el-input__inner {
  border: none !important;
  padding: 0 !important;
  width: 100% !important;
}
.input_select_table {
  padding: 0 !important;
  width: 180px;
  height: 40px;

  opacity: 1;
  border-radius: 10px;
  margin-left: 10px;
  padding: 0 15px !important;
}
.fill_in_title_l {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  color: #ff0e0e;
}
</style>


// WEBPACK FOOTER //
// src/views/SeniorAaccount/pickUp.vue